const state = {
  message: {
    type: '',
    text: ''
  }
}

const mutations = {
  updateMessage(state, params) {
    state.message = {
      type: params[0],
      text: params.length > 1 ? params[1] : ''
    }
  }
}

const getters = {
  getMessage(state) {
    return state.message
  }
}

const actions = {
  triggerMessage({ commit }, payload) {
    commit('updateMessage', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
